<script setup lang="ts">
import { NTabPane, NTabs } from "naive-ui";
import { watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { queryRef } from "../router/helpers.ts";
import BankAccounts from "./ConfigTabs/BankAccounts.vue";
import Credentials from "./ConfigTabs/Credentials.vue";
import Properties from "./ConfigTabs/Properties.vue";
import Team from "./ConfigTabs/Team.vue";
import Vendors from "./ConfigTabs/Vendors.vue";

const tab = queryRef("config-tab", "team");
const route = useRoute();
const router = useRouter();

const propertyQueryParams = [
    "properties-search",
    "properties-proper-scope",
    "properties-groups",
    "properties-types",
    "property-notes-and-activity",
    "property-drawer-tab",
];
const bankAccountQueryParams = [
    "bank-accounts-search",
    "bank-accounts-proper-scope",
    "bank-accounts-corporate-flag",
    "bank-accounts-bank-names",
    "bank-accounts-property-ids",
    "bank-account-notes-and-activity",
    "bank-account-drawer-tab",
];

watch(
    () => tab.value,
    (nextTab) => {
        const nextQuery = { ...route.query, "config-tab": nextTab };
        if (nextTab !== "properties") {
            for (const param of propertyQueryParams) {
                delete (nextQuery as any)[param];
            }
        }
        if (nextTab !== "bankAccounts") {
            for (const param of bankAccountQueryParams) {
                delete (nextQuery as any)[param];
            }
        }
        router.replace({ query: nextQuery });
    },
);
</script>

<template>
    <main class="flex flex-col mt-8 mx-2 sm:mx-4 lg:mx-10">
        <h1 class="text-2xl font-semibold mb-6">Configuration</h1>
        <n-tabs type="line" animated v-model:value="tab">
            <n-tab-pane name="team" tab="Team">
                <team />
            </n-tab-pane>
            <n-tab-pane name="properties" tab="Properties">
                <properties />
            </n-tab-pane>
            <n-tab-pane name="bankAccounts" tab="Bank Accounts">
                <bank-accounts />
            </n-tab-pane>
            <n-tab-pane name="vendors" tab="Vendors">
                <vendors />
            </n-tab-pane>
            <n-tab-pane name="credentials" tab="Credentials">
                <credentials />
            </n-tab-pane>
        </n-tabs>
    </main>
</template>
